<template>
  <router-link class="card-wrapper" :to="{name: 'StudentLibraryPage', params: {uuid: studentId}}">
    <div class="student-card">
      <div class="student-card__body">
        <h2 class="student-card__name ellipsis fs-block">{{ student.name }}</h2>
        <h3 class="student-card__subheader">{{ resourcesBlurb }}</h3>
      </div>
      <div class="card-footer">
        <i class="fa fa-calendar" aria-hidden="true"/> Last updated {{ updatedTimeAgo }}
      </div>
    </div>
  </router-link>
</template>

<script>
import { savedWhen } from '@/util/time'

export default {
  name: 'StudentCard',
  data() {
    return {}
  },
  props: {
    student: {
      type: Object,
      required: true
    }
  },
  computed: {
    updatedTimeAgo() {
      return savedWhen(this.student.updated_at)
    },
    studentId() {
      return this.student.uuid
    },
    resourcesBlurb() {
      if (this.student.n === 1) {
        return '1 resource'
      } else {
        return `${this.student.n} resources`
      }
    }
  }
}
</script>

<style scoped lang="less">
@import '~@/mixins.less';
@import '~@/variables.less';
@import '~@/globalstyles.less';

.card-wrapper {
  display: block;
  width: 100%%;
}

.student-card {
  .paper-card;
  background-color: #fafafa;
  margin-bottom: 15px;
  &:hover {
    background-color: #fffddd;
  }
  text-align: left;
}
a {
  text-decoration: none;
  color: inherit;
  display: block;
  &:hover,
  &:focus {
    text-decoration: none;
    color: inherit;
  }
}
.student-card__subheader {
  .gb-text-2;
  color: @gray-light;
  margin-bottom: 0;
  margin-top: 0;
}
.student-card__name {
  margin-top: 0;
}
.student-card__body {
  padding: 20px;
}
</style>
